export default "__VITE_ASSET__Bdve6Oy$__"